export type KeysOfType<T, U> = {
  [K in keyof T]: T[K] extends U ? K : never;
}[keyof T];

/**
 * Filters the data by matching the search query on the provided properties. Matches any word (&&) case insensitive
 *
 * @param userData [] Array of data that should be filtered
 * @param searchQuery string The filter query that will be separated by spaces the spaces
 * @param filterByStringProperties string[] Array of keys of the useData where the value type equals a string. If first property yields no result, use the next provided property.
 * @returns The filtered userData
 */
export const filterByStringProperty = <T extends Record<string, any>, Kstring extends KeysOfType<T, string>>(
  userData: T[],
  searchQuery: string,
  filterByStringProperties: Kstring[],
) =>
  userData.filter((user) => {
    if (searchQuery.length <= 1) {
      return true;
    }

    const regexPartsString = searchQuery
      .split(' ')
      .map((query) => `(?=.*${query})`)
      .join('');

    const regex = new RegExp(`${regexPartsString}.*`, 'gi'); // match any word case insensitive
    return filterByStringProperties.some((property) => user[property].match(regex)); //user.name.match(regex) || user.email.match(regex);
  });
